import api from "./client";

export const listArrayInverters = async () => {
  const { data } = await api.get("/arrayinverters/");
  return data;
};

export const listArrayInvertersBySite = async (siteId) => {
  const { data } = await api.get(`/arrayinverters/site/${siteId}`);
  return data;
};

export const listArrayInvertersDetailedBySite = async (siteId) => {
  const { data } = await api.get(`/arrayinverters/site/${siteId}/detailed/`);
  return data;
};

export const createArrayInverter = async (payload) => {
  const { data } = await api.post("/arrayinverters/", payload);
  return data;
};

// ✅ NEW: update existing inverter array (PUT)
export const updateArrayInverter = async (id, payload) => {
  const { data } = await api.put(`/arrayinverters/${id}`, payload);
  return data;
};

export const deleteArrayInverter = async (id) => {
  const { data } = await api.delete(`/arrayinverters/${id}/`);
  return data;
};
